import { WEB_API_ROUTES } from 'api/api-routes';
import api from 'api';
import { createThunk } from '../../utils/storeUtils';

export const thunks = {
  getAppointments: createThunk('scheduler/getAppointments', ({ start, end }) =>
    api.get(WEB_API_ROUTES.schedule.appointments, {
      params: { start, end },
    })
  ),

  storeAppointment: createThunk('scheduler/storeAppointment', (data) =>
    api.post(WEB_API_ROUTES.schedule.createAppointment, data, {
      params: { app: 'studio' },
    })
  ),

  updateAppointment: createThunk('scheduler/updateAppointment', (data) =>
    api.post(WEB_API_ROUTES.schedule.updateAppointment, data, {
      params: { app: 'studio' },
    })
  ),

  deleteAppointment: createThunk(
    'scheduler/deleteAppointment',
    (appointmentId) =>
      api.delete(
        WEB_API_ROUTES.schedule.deleteAppointment.replace(
          '{appointmentId}',
          appointmentId
        ),
        { params: { app: 'studio' } }
      )
  ),

  removeAppointmentMedia: createThunk(
    'scheduler/removeAppointmentMedia',
    (medias) =>
      api.post(WEB_API_ROUTES.schedule.removeAppointmentMedia, { medias })
  ),

  rejectRequest: createThunk('scheduler/rejectRequest', ({ requestId }) =>
    api.post(
      WEB_API_ROUTES.schedule.rejectRequest,
      { request_id: requestId },
      { params: { app: 'studio' } }
    )
  ),

  approveRequest: createThunk('scheduler/approveRequest', (data) =>
    api.post(WEB_API_ROUTES.schedule.approveRequest, data, {
      params: { app: 'studio' },
    })
  ),

  sendEmail: createThunk(
    'scheduler/sendEmail',
    ({ subject, messageText, messageFor }) =>
      api.post(WEB_API_ROUTES.schedule.sendEmail, {
        messageFor,
        subject,
        messageText,
      })
  ),

  sendSms: createThunk('scheduler/sendSms', ({ messageText, messageFor }) =>
    api.post(WEB_API_ROUTES.schedule.sendSms, {
      messageText,
      messageFor,
    })
  ),

  cancelAppointment: createThunk(
    'scheduler/cancelAppointment',
    (appointmentId) =>
      api.delete(
        WEB_API_ROUTES.schedule.cancelAppointment.replace(
          '{appointmentId}',
          appointmentId
        ),
        { params: { app: 'studio' } }
      )
  ),

  updateRating: createThunk(
    'scheduler/updateRating',
    ({ studentId, scheduleId, stars, hearts }) =>
      api.post(WEB_API_ROUTES.schedule.updateDancerRating, {
        student_id: studentId,
        schedule_id: scheduleId,
        stars,
        hearts,
      })
  ),

  updateAttendance: createThunk(
    'scheduler/updateAttendance',
    ({ studentId, scheduleId, attendance }) =>
      api.post(WEB_API_ROUTES.schedule.updateAttendance, {
        student_id: studentId,
        schedule_id: scheduleId,
        attendance,
      })
  ),

  storeUnavailable: createThunk('scheduler/storeUnavailable', (data) =>
    api.post(WEB_API_ROUTES.schedule.storeUnavailable, data, {
      params: { app: 'studio' },
    })
  ),

  updateUnavailable: createThunk('scheduler/updateUnavailable', (data) => {
    const appointmentId = data.get('appointment_id');
    data.delete('appointment_id');

    return api.post(
      WEB_API_ROUTES.schedule.updateUnavailable.replace(
        '{appointmentId}',
        appointmentId
      ),
      data,
      { params: { app: 'studio' } }
    );
  }),

  storeInternal: createThunk('scheduler/storeInternal', (data) =>
    api.post(WEB_API_ROUTES.schedule.storeInternal, data, {
      params: { app: 'studio' },
    })
  ),

  updateInternal: createThunk('scheduler/updateInternal', (data) => {
    const appointmentId = data.get('appointment_id');
    data.delete('appointment_id');

    return api.post(
      WEB_API_ROUTES.schedule.updateInternal.replace(
        '{appointmentId}',
        appointmentId
      ),
      data,
      { params: { app: 'studio' } }
    );
  }),
};
